module.exports = __webpack_public_path__ + "@/assets/img/question-circle.fd17a7f8.svg";